export default function Solutions() {
  return (
    <section id="solutions" className="py-24 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)',
          backgroundSize: '50px 50px'
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <div className="text-teal-400 text-sm font-semibold tracking-wider uppercase mb-4">
              SOLUTIONS
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
              Automated Assessment<br />& Migration<br />Services
            </h2>
            <p className="text-gray-300 text-lg leading-relaxed mb-8">
              Our consulting services provide comprehensive automated assessments for data center networks, remote office networks, and cloud infrastructure. We deliver actionable insights and migration strategies that ensure zero downtime and optimal performance.
            </p>
            <button className="px-8 py-4 bg-gradient-to-r from-teal-500 to-cyan-600 text-white font-semibold rounded-lg hover:from-teal-600 hover:to-cyan-700 transition-all cursor-pointer whitespace-nowrap shadow-lg">
              Request Consultation
            </button>

            <div className="grid grid-cols-2 gap-6 mt-12">
              <div className="border border-gray-700 rounded-lg p-6 bg-white/5 backdrop-blur-sm">
                <div className="text-3xl font-bold text-white mb-2">200+</div>
                <div className="text-gray-400 text-sm">Assessments Completed</div>
              </div>
              <div className="border border-gray-700 rounded-lg p-6 bg-white/5 backdrop-blur-sm">
                <div className="text-3xl font-bold text-white mb-2">100%</div>
                <div className="text-gray-400 text-sm">Zero Downtime Migrations</div>
              </div>
            </div>
          </div>

          {/* Right Visual */}
          <div className="relative">
            <img
              src="https://public.readdy.ai/ai/img_res/94833a2e62c9a3f8bcbe41441d9f6ccf.jpg"
              alt="Data Center Solutions"
              className="w-full h-auto rounded-xl shadow-2xl"
            />
            
            {/* Floating Cards */}
            <div className="absolute top-8 -left-4 bg-white/10 backdrop-blur-md rounded-lg p-4 border border-white/20 shadow-xl">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 rounded-lg bg-teal-500 flex items-center justify-center">
                  <i className="ri-check-line text-white text-xl"></i>
                </div>
                <div>
                  <div className="text-white font-semibold text-sm">Assessment Complete</div>
                  <div className="text-gray-300 text-xs">Network optimized</div>
                </div>
              </div>
            </div>

            <div className="absolute bottom-8 -right-4 bg-white/10 backdrop-blur-md rounded-lg p-4 border border-white/20 shadow-xl">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 rounded-lg bg-cyan-500 flex items-center justify-center">
                  <i className="ri-speed-line text-white text-xl"></i>
                </div>
                <div>
                  <div className="text-white font-semibold text-sm">99.9% Uptime</div>
                  <div className="text-gray-300 text-xs">Performance metrics</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
